import React, { useEffect, useState } from 'react';

export const LeadFormBgSlides = ({ urls = [], interval = 6000 }) => {
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * Math.max(urls.length, 1)));

  useEffect(() => {
    if (urls.length < 2) return;
    const t = setInterval(() => {
      setIdx(prev => {
        let next = prev;
        while (next === prev) next = Math.floor(Math.random() * urls.length);
        return next;
      });
    }, interval);
    return () => clearInterval(t);
  }, [urls.length, interval]);

  if (!urls.length) return null;
  return (
    <div className="absolute inset-0" data-testid="lead-form-bg-slides">
      {urls.map((u, i) => (
        <div
          key={u + i}
          className="absolute inset-0 bg-cover bg-center transition-opacity duration-[1500ms]"
          style={{ backgroundImage: `url(${u})`, opacity: i === idx ? 1 : 0 }}
        />
      ))}
    </div>
  );
};
